<template>
	<checkout-block>
		<checkout-block-header>Betalingsmetode</checkout-block-header>

		<checkout-block-body class="text-base">
			<div class="inline-flex h-5 items-center">
				<div class="font-bold">Vælg metode</div>
				<div
					v-if="calculatedMissingFields == 0 && hasTriedToCheckout"
					class="ml-4"
				>
					<svg
						width="20"
						height="20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<rect width="20" height="20" rx="10" fill="#4E9036" />
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M8.472 12.195L14.667 6l.943.943-7.138 7.138-3.805-3.805.943-.943 2.862 2.862z"
							fill="#fff"
						/>
					</svg>
				</div>
			</div>

			<div v-if="basket.AllowEanPayment">
				<label
					class="inline-flex items-start font-normal mt-2 cursor-pointer"
				>
					<input
						type="radio"
						style="margin-top:.125rem"
						class="form-radio mt-1 text-top focus:outline-none w-4 h-4"
						v-model="basket.PaymentMethod"
						value="ean"
						@change="saveBillingData()"
					/>
					<span class="ml-2">EAN</span>
				</label>
			</div>

			<div v-if="basket.AllowInvoicePayment">
				<label
					class="inline-flex items-start font-normal mt-2 cursor-pointer"
				>
					<input
						type="radio"
						style="margin-top:.125rem"
						class="form-radio mt-1 text-top focus:outline-none w-4 h-4"
						v-model="basket.PaymentMethod"
						value="invoice"
						@change="saveBillingData()"
					/>
					<span class="ml-2">Faktura</span>
				</label>
			</div>

			<div v-if="basket.AllowCardPayment">
				<label
					class="inline-flex items-start font-normal mt-2 cursor-pointer"
				>
					<input
						type="radio"
						style="margin-top:.125rem"
						class="form-radio mt-1 text-top focus:outline-none w-4 h-4"
						v-model="basket.PaymentMethod"
						value="card"
						@change="saveBillingData()"
					/>
					<span class="ml-2">
						Betalingskort<span v-if="cardLogos.mobilePay"> eller MobilePay</span
						><br />
						<span class="text-xs text-gray-900">
							Kort der kan benyttes til betalingskort<span
								v-if="cardLogos.mobilePay"
								>- og MobilePay</span
							>
							betaling:<br />
							<card-logos :card-logos="cardLogos" />
						</span>
					</span>
				</label>
			</div>

			<div v-if="basket.PaymentMethod == 'ean'">
				<div class="flex -ml-2 mt-6">
					<participant-field
						label="EAN nummer"
						v-model="basket.EanNumber"
						:pattern="'^\\d{13}$'"
						:pattern-error-message="'EAN nummeret skal bestå af 13 cifre'"
						:show-valid="isValid('EanNumber')"
						:show-pattern-message="isPatternMissing('EanNumber')"
						:required="true"
						:show-required-message="isMissing('EanNumber')"
						@blur="
							[saveBillingData(), validate('EanNumber'), validatePattern('EanNumber', '^\\d{13}$')]
						"
						@keyup="
							[
								saveBillingData(),
								validate('EanNumber', true), validatePattern('EanNumber', '^\\d{13}$', true)
							]
						"
						@change="
							[
								saveBillingData(),
								validate('EanNumber', true), validatePattern('EanNumber', '^\\d{13}$', true)
							]
						"
					/>
				</div>
				<div class="flex -ml-2 mt-6">
					<participant-field
						label="CVR nummer"
						v-model="basket.CvrNumber"
						:pattern="'^\\d{8,}$'"
						:pattern-error-message="'CVR nummeret skal bestå af min. 8 cifre'"
						:show-valid="isValid('CvrNumber')"
						:show-pattern-message="isPatternMissing('CvrNumber')"
						:required="true"
						:show-required-message="isMissing('CvrNumber')"
						@blur="
							[saveBillingData(), validate('CvrNumber'), validatePattern('CvrNumber', '^\\d{8,}$')]
						"
						@keyup="
							[
								saveBillingData(),
								validate('CvrNumber', true)
							]
						"
						@change="
							[
								saveBillingData(),
								validate('CvrNumber', true)
							]
						"
					/>
				</div>
			</div>

			<transition
				enter-active-class="transition-all duration-3s timing-ease"
				leave-active-class="transition-all duration-3s timing-ease"
				enter-class="opacity-0 scale-y-0 -translate-y-full"
				enter-to-class="opacity-1 scale-y-100 translate-y-0"
				leave-class="opacity-1 scale-y-100 translate-y-0"
				leave-to-class="opacity-0 scale-y-0 -translate-y-full"
			>
				<div v-if="hasTriedToCheckout && !paymentMethodSelected">
					<div
						class="bg-red-700 inline-block mt-2 text-white p-1 rounded-sm font-normal text-micro sm:text-xs"
					>
						Du skal vælge en betalingsmetode
					</div>
				</div>
			</transition>
		</checkout-block-body>
	</checkout-block>
</template>
<script>
import ParticipantField from "./ParticipantField";
import CardLogos from "./CardLogos";

export default {
	props: {
		cardLogos: Object
	},
	data: function() {
		return {
			validatedFields: [],
			validFields: [],
			validPatterns: [],
			missingFields: [],
			missingPatterns: []
		};
	},
	components: {
		ParticipantField,
		CardLogos
	},
	computed: {
		paymentMethodSelected: function() {
			return (
				this.basket.PaymentMethod != null &&
				this.basket.PaymentMethod.length > 0
			);
		},
		hasTriedToCheckout: function() {
			return this.$store.getters.hasTriedToCheckout;
		},
		basket: function() {
			return this.$store.getters.basket;
		},
		calculatedMissingFields: function() {
			var fields = !this.paymentMethodSelected ? 1 : 0;

			if (this.basket.PaymentMethod == "ean") {
				var missing = this.missingFields.concat(this.missingPatterns);
				fields = fields + [...new Set(missing)].length;
			}

			return fields;
		}
	},
	methods: {
		saveBillingData: function() {
			this.$store.dispatch("saveBasket", this.$store.getters.basket);
			this.validateAll();
		},
		isValid: function(fieldName) {
			return (
				this.validatedFields.indexOf(fieldName) > -1 &&
					this.validFields.indexOf(fieldName) > -1 &&
					!this.isPatternMissing(fieldName)
			);
		},
		isMissing: function(fieldName) {
			return this.missingFields.indexOf(fieldName) > -1;
		},
		isPatternMissing: function(fieldName) {
			return this.missingPatterns.indexOf(fieldName) > -1;
		},
		validate: function(property, ifInvalid) {
			if (!ifInvalid || this.isMissing(property)) {
				this.validatedFields.push(property);
				this.validFields = this.validFields.filter(f => f != property);
				this.missingFields = this.missingFields.filter(f => f != property);
				var valid = this.basket[property] && this.basket[property] != "";

				if (!valid) {
					this.missingFields.push(property);
				} else {
					this.validFields.push(property);
				}
				this.reportValidation();
			}
		},
		validatePattern: function(property, pattern, ifInvalid) {
			if (!ifInvalid || this.isPatternMissing(property)) {
				if (pattern !== "") {
					this.validatedFields.push(property);
					this.validPatterns = this.validPatterns.filter(f => f != property);
					this.missingPatterns = this.missingPatterns.filter(
						f => f != property
					);
					var valid =
						this.basket[property] && this.basket[property].match(pattern);

					if (!valid) {
						this.missingPatterns.push(property);
					} else {
						this.validPatterns.push(property);
					}
					this.reportValidation();
				}
			}
		},
		reportValidation: function() {
			this.$store.dispatch("reportValidation", {
				olIndex: "payment",
				index: "payment",
				missingFields: this.calculatedMissingFields
			});
		},
		validateAll: function() {
			if (this.hasTriedToCheckout) {
				if (this.basket.PaymentMethod == "ean") {
					this.validate("CvrNumber");
					this.validatePattern("CvrNumber", "\\d{8}");
					this.validate("EanNumber");
					this.validatePattern("EanNumber", "\\d{13}");
				}
				this.reportValidation();
			}
		}
	},
	mounted: function() {
		this.validateAll();
	},
	watch: {
		hasTriedToCheckout: function() {
			this.validateAll();
		}
	}
};
</script>
